import { render, staticRenderFns } from "./LbCorpolatePlanSubmit.vue?vue&type=template&id=203bc404&"
import script from "./LbCorpolatePlanSubmit.vue?vue&type=script&lang=js&"
export * from "./LbCorpolatePlanSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports